import axios from "axios";
import { InterceptorFactoryInterface, InterceptorInterface } from "..";
import { getFromLocalSession } from "./LocalStorage";





export class InterceptorFactory implements InterceptorFactoryInterface {

    responseInterceptors: any[];
    requestInterceptors: any[];

    constructor () {
        this.responseInterceptors = [];
        this.requestInterceptors =[];
    }


    createResponseInterceptor(callback : Function) {
        this.responseInterceptors.push( axios.interceptors.response.use(
            response => {
                return response;
            }, error => {
                callback(error);
                return Promise.reject(error);
            }
        ))
    }


    createRequestInterceptor(callback: Function) {
        this.requestInterceptors.push( axios.interceptors.request.use(
            request => {
                callback(request);                
                return request;
            }, error => {
                return Promise.reject(error);
            }
        ))
    }


    deleteResponseInterceptors() {
        this.responseInterceptors.forEach((i)=>axios.interceptors.response.eject(i));
    }

    deleteRequestInterceptors() {
        this.requestInterceptors.forEach((i) => axios.interceptors.request.eject(i));
    }


    deleteAllInterceptors() {
        console.log("Deleting interceptors");
        this.deleteRequestInterceptors();
        this.deleteResponseInterceptors();
    }


}
